const GooglePlayBadge = () => (
  <svg
    width="158"
    height="47"
    viewBox="0 0 158 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect
      x="0.5"
      y="0.5"
      width="157"
      height="46"
      rx="7.5"
      fill="white"
      stroke="#A6A6A6"
    />
    <path
      d="M13.54 8.66c-.38.46-.58 1.05-.55 1.65v25.9c-.04.6.15 1.18.54 1.64l.09.09 14.5-14.5v-.34L13.63 8.57l-.09.09z"
      fill="url(#gp_a)"
    />
    <path
      d="M32.95 28.2l-4.83-4.83v-.34l4.83-4.83.11.06 5.73 3.26c1.64.93 1.64 2.45 0 3.38l-5.73 3.26-.11.04z"
      fill="url(#gp_b)"
    />
    <path
      d="M33.06 28.14l-4.94-4.94L13.54 37.78c.55.57 1.44.64 2.44.07l17.08-9.71z"
      fill="url(#gp_c)"
    />
    <path
      d="M33.06 18.26L15.98 8.54c-1-.57-1.89-.5-2.44.07l14.58 14.59 4.94-4.94z"
      fill="url(#gp_d)"
    />
    <text
      x="49"
      y="17"
      fill="#333"
      fontFamily="Arial, Helvetica, sans-serif"
      fontSize="9"
      fontWeight="400">
      Disponível na
    </text>
    <text
      x="49"
      y="33"
      fill="#333"
      fontFamily="Arial, Helvetica, sans-serif"
      fontSize="16"
      fontWeight="600">
      Google Play
    </text>
    <defs>
      <linearGradient
        id="gp_a"
        x1="26.85"
        y1="10.03"
        x2="7.2"
        y2="29.68"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#00A0FF" />
        <stop offset="1" stopColor="#00E3FF" />
      </linearGradient>
      <linearGradient
        id="gp_b"
        x1="40.92"
        y1="23.2"
        x2="12.59"
        y2="23.2"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFE000" />
        <stop offset="1" stopColor="#FF9C00" />
      </linearGradient>
      <linearGradient
        id="gp_c"
        x1="30.37"
        y1="25.89"
        x2="3.72"
        y2="52.54"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#FF3A44" />
        <stop offset="1" stopColor="#C31162" />
      </linearGradient>
      <linearGradient
        id="gp_d"
        x1="9.85"
        y1="0.04"
        x2="21.75"
        y2="11.94"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#32A071" />
        <stop offset="1" stopColor="#00F076" />
      </linearGradient>
    </defs>
  </svg>
)

export default GooglePlayBadge
